var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585632 7.30273C0.446116 7.30273 0.333008 7.41583 0.333008 7.55536V11.2689C0.333008 13.6209 1.8437 15.2014 4.09205 15.2014H12.5726C14.8218 15.2014 16.3325 13.6209 16.3325 11.2689V7.55536C16.3325 7.41583 16.2194 7.30273 16.0799 7.30273H0.585632Z",
    fill: "#C6E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0799 6.04047C16.2194 6.04047 16.3325 5.92737 16.3325 5.78784V5.7289C16.3325 3.37697 14.8218 1.79639 12.5726 1.79639H4.09205C1.8437 1.79639 0.333008 3.37697 0.333008 5.7289V5.78784C0.333008 5.92737 0.446107 6.04047 0.585632 6.04047H16.0799Z",
    fill: "#3694FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27121 11.8027H6.77137C7.12 11.8027 7.40293 11.5197 7.40293 11.1711C7.40293 10.8225 7.12 10.5396 6.77137 10.5396H4.27121C3.92259 10.5396 3.63965 10.8225 3.63965 11.1711C3.63965 11.5197 3.92259 11.8027 4.27121 11.8027Z",
    fill: "#3694FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardMenu);
export default __webpack_public_path__ + "static/media/credit_card_menu.81dc399ff5cab603e64c16f82430a102.svg";
export { ForwardRef as ReactComponent };